module.exports = __webpack_public_path__ + "img/james watkins, 1977.8809d425.jpg";